import React from 'react'

const GlassIcon = props => (
  <svg viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.37963 5.42215C1.90705 5.26457 0.756348 4.01443 0.756348 2.50082C0.756348 1.88908 0.890974 1.29527 1.0213 0.720982C1.05687 0.564215 1.09244 0.407448 1.12518 0.250471L1.17744 0H6.2113L6.26355 0.250471C6.29629 0.407448 6.33176 0.564215 6.36744 0.720982C6.49787 1.29527 6.63249 1.88908 6.63249 2.50082C6.63249 4.01463 5.48179 5.26459 4.00922 5.42215V8.34641C4.00922 8.35449 4.00891 8.36249 4.00832 8.37041H5.6882C5.86207 8.37041 6.003 8.51133 6.003 8.68521C6.003 8.85908 5.86207 9 5.6882 9H1.70082C1.52695 9 1.38602 8.85908 1.38602 8.68521C1.38602 8.51133 1.52695 8.37041 1.70082 8.37041H3.38053C3.37993 8.36249 3.37963 8.35448 3.37963 8.34641V5.42215ZM1.63525 0.860226C1.65277 0.783416 1.67019 0.706397 1.6873 0.629587H5.70154C5.71865 0.706397 5.73607 0.783416 5.75359 0.860226C5.88181 1.42559 6.00291 1.95959 6.00291 2.50082C6.00291 3.77364 4.96734 4.80931 3.69442 4.80931C2.4215 4.80931 1.38593 3.77374 1.38593 2.50082C1.38593 1.95959 1.50703 1.42559 1.63525 0.860226ZM1.70142 2.49763C1.7015 2.49652 1.70158 2.49541 1.70158 2.49429H5.68749C5.68749 2.49533 5.68757 2.49639 5.68765 2.49747C5.68773 2.49857 5.68781 2.49968 5.68781 2.5008C5.68781 3.60174 4.79537 4.49407 3.69454 4.49407C2.5937 4.49407 1.70126 3.60174 1.70126 2.5008C1.70126 2.49976 1.70134 2.4987 1.70142 2.49763Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="8.15404"
        y1="-1.54553"
        x2="-0.896281"
        y2="10.7839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default GlassIcon
